import request from "../../utils/api";

export const getMaintainedValues = params => {
  return request("v1/mv", {
    params
  });
};
